import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './app/App';
import './styles/globals.css';

// Базовый путь для маршрутизации
// При развёртывании на GitVerse/GitHub Pages используется /github-lessons/
const basename = import.meta.env.BASE_URL || '/github-lessons/';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
